export default function () {
  const preloaderEl = window.document.querySelector('.c-preloader');
  const bookingLayout = window.document.querySelector('booking-layout');

  function hidePreloader() {
    if (!preloaderEl) return;
    preloaderEl.style.opacity = 0;
    // eslint-disable-next-line no-underscore-dangle
    window.__preloaderDone = true;
    document.dispatchEvent(new CustomEvent('preloader:done', { bubbles: true }));
  }

  function bookingPageLoaded() {
    if (!bookingLayout) {
      return;
    }

    window.document.addEventListener('azdsBookingReady', hidePreloader);
  }

  function regularPageLoaded() {
    if (bookingLayout) {
      window.document.addEventListener('azdsBookingReady', hidePreloader);
      return;
    }

    if (document.readyState === 'complete') {
      hidePreloader();
    } else {
      // Cap preloader at 3s so third-party scripts (OneTrust, analytics) don't delay LCP on slow connections
      const maxWait = setTimeout(hidePreloader, 3000);
      window.addEventListener('load', () => { clearTimeout(maxWait); hidePreloader(); }, { once: true });
    }
  }

  if (preloaderEl) {
    regularPageLoaded();
    bookingPageLoaded();

    preloaderEl.addEventListener('transitionend', () => {
      preloaderEl.remove();
    }, { once: true });
  }
}
